module.exports = __webpack_public_path__ + "static/assets/c5878283609ef7486c74163ce76bae67.png";